export function getBeaconVoltageStatus(millivolts: number): { color: string; label: string } | null {
  if (!Number.isFinite(millivolts) || millivolts < 0) return null;
  if (millivolts >= 2800) return { color: "#1976d2", label: "Ausgezeichnet" };
  if (millivolts >= 2500 && millivolts < 2800) return { color: "#2e7d32", label: "Betriebsbereich" };
  if (millivolts >= 2200 && millivolts < 2500) return { color: "#d6a000", label: "Niedrig (ca. 10–15 % verbleibend)" };
  if (millivolts > 2000) return { color: "#ed6c02", label: "Sehr niedrig (ca. 0–10 % verbleibend)" };
  if (millivolts <= 2000) return { color: "#d32f2f", label: "Leer" };
  return null;
}
